import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';
import { variation } from 'ember-launch-darkly';
import { and } from 'ember-truth-helpers';
import { LayoutSidebarSubnav } from 'core/components';

<template>
  {{pageTitle (t "page-title.access-control.service-principals.detail")}}

  <LayoutSidebarSubnav as |Subnav|>
    <Subnav.BackLink
      @text={{t
        "components.page.access-control.service-principals.subnav.back"
      }}
      @route="cloud.access-control.service-principals.list"
    />
    <Subnav.Title>
      {{@controller.model.servicePrincipal.name}}
    </Subnav.Title>
    <Subnav.Link
      @current-when="cloud.access-control.service-principals.detail.index cloud.access-control.service-principals.detail.edit"
      @route="cloud.access-control.service-principals.detail"
      @text={{t
        "components.page.access-control.service-principals.subnav.details.title"
      }}
    />
    <Subnav.Link
      @route="cloud.access-control.service-principals.detail.keys"
      @text={{t
        "components.page.access-control.service-principals.details.keys.header.title"
      }}
    />
    {{#if
      (and
        @controller.model.isProjectContext
        (variation "hcp-ui-workload-identity-aws")
      )
    }}
      <Subnav.Link
        @route="cloud.access-control.service-principals.detail.workload-identity-providers"
        @text={{t
          "components.page.access-control.service-principals.details.workload-identity-providers.header.title"
        }}
      />
    {{/if}}
  </LayoutSidebarSubnav>

  {{outlet}}
</template>
